export const WEIGHT_OPTIONS = [
  { id: "sub250", label: "< 250g", sub: "A1 / C0" },
  { id: "a2", label: "250–900g", sub: "A2 / C1" },
  { id: "heavy", label: "> 900g", sub: "A2 CofC / A3" },
];

export const DroneClassSelector = ({ value, onChange }) => (
  <div data-testid="drone-class-selector" className="flex gap-1 p-1 bg-white/5 rounded-full border border-white/10">
    {WEIGHT_OPTIONS.map((opt) => (
      <button
        key={opt.id}
        data-testid={`drone-class-${opt.id}`}
        onClick={() => onChange(opt.id)}
        className={`flex-1 py-2 px-2 rounded-full text-center transition-colors duration-200 ${
          value === opt.id
            ? "bg-[#2ec4b6] text-black"
            : "text-zinc-400 hover:text-white hover:bg-white/5"
        }`}
      >
        <span className="block text-xs font-semibold font-heading">{opt.label}</span>
        <span className={`block text-[9px] uppercase tracking-wider ${value === opt.id ? "text-black/60" : "text-zinc-600"}`}>
          {opt.sub}
        </span>
      </button>
    ))}
  </div>
);
